import React, {useEffect,useState} from "react";
import './VerticalAccrodion.scss'

// Tab data structure
// {
//     "icon": "",
//     "header": "",
//     "text": "",
//     "img": ""
// }
// props style options = 'icon' or 'abc'

const VerticalAccrodion = (props) =>{
    const [tabs, setTabs] = useState([]);
    const [showTab, setShowTab] = useState(null);
    const [style, setStyle] = useState( );

    let craftData = (data) =>{
        let fakeTabs = tabs;
        data.map((data, i)=>{
            let newObj =  {
                "icon": data.icon? data.icon:"",
                "header": data.header? data.header:"",
                "text": data.text? data.text:"",
                "img": data.img? data.img:""
            };
            fakeTabs.push(newObj);
        })
        setTabs(fakeTabs);
    }

    let tabClick = (i) =>{
        if(showTab === i){
            setShowTab(null);
        }else if(showTab !== i){
            setShowTab(i);
        }
    }

    useEffect(()=>{
        if(props.data) craftData(props.data);
        if(props.style) setStyle(props.style)
    },[])

    useEffect(()=>{
        console.log(tabs)
    },[tabs])

    return(
        <div className="VerticalTabs">
            {tabs.length > 0 && tabs.map((tab,i)=>{
                return(
                    <div className="tab" onClick={()=>tabClick(i)} key={i}>
                        {style === 'icon'&&
                            <div className={`tabLeft ${showTab === i&& "show"}`}>
                                <div className="tabHeader">
                                    <img src={tab.icon} alt={`Tab Icon`} />
                                    <h3>{tab.header.toUpperCase()}</h3>
                                </div>
                            </div>
                        }
                        {style === 'abc' &&
                        <div className={`abc_tab ${showTab === i&& "show"}`}>
                            <h3 className="tabHeader">{String.fromCharCode(i+65)}</h3>
                        </div>
                        }
                        <div className={`tabRight ${showTab === i&& "show"}`}>
                            <p>{tab.text}</p>
                            <img src={tab.img} alt={"Tab Image"} />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default VerticalAccrodion;